var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTickGreen = function SvgTickGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    height: "100%",
    width: "100%"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.084 13c.466 0 .823-.194 1.071-.581l6.59-10.535a1.69 1.69 0 0 0 .196-.412c.04-.132.059-.26.059-.385 0-.318-.101-.58-.304-.782A1.05 1.05 0 0 0 11.92 0c-.218 0-.4.044-.545.131-.145.088-.287.24-.427.46l-5.9 9.69-3.042-4.057c-.248-.313-.55-.47-.908-.47-.32 0-.584.104-.79.31C.104 6.27 0 6.536 0 6.861c0 .144.024.283.073.417.048.134.133.273.254.417l3.686 4.752c.29.369.647.553 1.07.553Z",
    fill: "#1BA287"
  })));
};

export default SvgTickGreen;